import _ from 'lodash.escape';
import { lookupQuery } from '../modules/lookup-result-handler';
import { handleDeliverabilityAlert } from '../modules/deliverability-alerts';

const lookup = (lookupType, onFailed) => {
    lookupQuery(lookupType, (result, records) => {
        try {
            const status = document.getElementById(`${lookupType}-status`);
            const content = JSON.parse(status.dataset.content);

            status.classList.add(content[result].class);
            status.textContent = content[result].label;

            document.getElementById(`${lookupType}-content`).innerHTML = records
                .map((value) => `<div>${_(value)}</div>`)
                .join('');

            if (typeof onFailed !== 'undefined' && result === 'notValid') {
                onFailed();
            }
        } catch (e) {
            console.log('Error in lookup', e);
        }
    });
};

const initialize = () => {
    lookup('mx');
    lookup('txt_spf', () => handleDeliverabilityAlert('spf'));
    lookup('mailcname');
    lookup('txt_dmarc', () => handleDeliverabilityAlert('dmarc'));
    lookup('cname_dkim', () => handleDeliverabilityAlert('dkim'));
    lookup('srv');
};

export default initialize;
